
<template>
  <div>
    <table class="table table-striped w-100" v-if="chats.length > 0">
      <thead>
        <tr>
          <th>Sl.No</th>
          <th>Title</th>
          <th>Username</th>
          <th>Chat ID</th>
          <th>Type</th>
          <th>Invite Link</th>
          <th>Status</th>
          <th>Leave Chat</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(chat,index) in chats" :key="index">
          <td>{{index+1}}</td>
          <td>{{ chat.title }}</td>
          <td><a :href="'https://t.me/'+chat.username" target="blank">{{ chat.username }}</a></td>
          <td>{{ chat.id }}</td>
          <td>{{ chat.type }}</td>
          <td><a :href="chat.invite_link" target="blank">{{ chat.invite_link }}</a></td>
          <td>{{ chat.status }}</td>
          <td>
            <button @click="$emit('leaveChat',chat.id)" class="btn btn-outline-danger btn-sm" v-if="chat.status!='left'">Leave</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ChatCard',
  props:{
    chats: Array,
  },
}

</script>
